<script setup lang="ts">
  import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'
  import { AUTO_COMP_CODE, DURATION_CODE, OCR_CODE } from '@/shared/constants/other.constants'
  import { useCoreStore } from '@/shared/store'
  import { useWebView } from '@qicgroupdoha/qic-use'
  import { inject, onBeforeMount, ref, watch } from 'vue'
  import { defineI18nKeys } from '@qicgroupdoha/qic-i18n'

  const { isWebView } = useWebView()
  const coreStore = useCoreStore()
  const gaService = useGoogleAnalytics()
  const localeRTL = inject<boolean>('localeRTL')
  const isLoading = ref(true)

  defineI18nKeys([
    'preappproval_duration_annotation.item_1',
    'preappproval_duration_annotation.item_2',
    'preappproval_duration_annotation.item_3',
    'preappproval_duration_annotation.item_4',
    'qic_landing_header_home_title',
    'qic_landing_header_pab_title',
    'includes_quote.item_1.desc',
    'includes_quote.item_2.desc',
    'includes_quote.item_3.desc',
    'includes_quote.item_4.desc',
    'includes_quote.item_5.desc',
    'includes_quote.item_6.desc',
    'not_covers.item_1.desc',
    'not_covers.item_2.desc',
    'includes_quote.item_1.title',
    'includes_quote.item_2.title',
    'includes_quote.item_3.title',
    'includes_quote.item_4.title',
    'includes_quote.item_5.title',
    'includes_quote.item_6.title',
    'not_covers.item_1.title',
    'not_covers.item_2.title',
  ])

  const setInitialReferrer = () => {
    let referrer = 'visitors'
    if (document.referrer.includes('travel-insurance')) {
      referrer = 'travel_inbound'
    }

    coreStore.setInitialReferrer(referrer)
  }

  if (!coreStore.initialReferrer) {
    setInitialReferrer()
  }

  const getAbTest = async (code: string) => {
    const value = await coreStore.getAbTest(code)
    if (value) {
      gaService.sendABTest(code, value)
    }
  }

  const sendWebViewApp = () => {
    if (!isWebView()) return

    const googleId = localStorage.getItem('GoogleID')
    if (googleId) {
      gaService.sendWebViewApp(googleId)
    }
  }

  onBeforeMount(async () => {
    await Promise.all([getAbTest(DURATION_CODE), getAbTest(AUTO_COMP_CODE), getAbTest(OCR_CODE)])
    isLoading.value = false

    sendWebViewApp()
  })

  watch(
    () => localeRTL,
    (newLocaleRTL) => {
      if (newLocaleRTL) {
        document.body.setAttribute('dir', newLocaleRTL ? 'rtl' : 'ltr')
      }
    },
    { immediate: true }
  )
</script>

<template>
  <router-view v-if="!isLoading" />
</template>
